import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

const toApplicationRequest = (application) => {
  if (!application.image) return application
  const data = new FormData()
  Object.entries(application).forEach(([key, value]) => {
    if (value !== undefined && value !== null) data.append(key, value)
  })
  return data
}

export const getApplications = async (params) => {
  const { data } = await clasolSuiteApi.get('/applications', {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getApplication = async (id) => {
  const { data } = await clasolSuiteApi.get(`/applications/${encodeURIComponent(id)}`, withSuiteAdminCode())
  return data
}

export const createApplication = async (application) => {
  const { data } = await clasolSuiteApi.post('/applications', toApplicationRequest(application), withSuiteAdminCode())
  return data
}

export const updateApplication = async (id, application) => {
  const { data } = await clasolSuiteApi.patch(`/applications/${encodeURIComponent(id)}`, toApplicationRequest(application), withSuiteAdminCode())
  return data
}

export const deleteApplication = async (id) => {
  await clasolSuiteApi.delete(`/applications/${encodeURIComponent(id)}`, withSuiteAdminCode())
}
